// ##### 25-02-05 Komarov
import React, { createContext, useMemo, useRef } from 'react';
// ##### 23-09-22 Komarov
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import LargeScreenSearch from './LargeScreenSearch';
// ##### 23-11-02 Komarov
import { Media } from '../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import SmallScreenSearchTag from './SmallScreenSearchTag';
// ##### Komarov 2025-08-21
import { usePerformanceMeasure } from '../../../../hooks/usePerformanceMeasure';

// ##### 23-09-14 Komarov
// import './Search.css';
// import './SwitcherFront.css';
// import 'antd/dist/antd.css';
// import './SmallScreenSearchCSS.css'

// ##### 24-05-22 Komarov
export const SearchContext = createContext();

// ##### Komarov 2025-07-21
const Search = ({ style }) => {
  // ##### Komarov 2025-08-27
  const componentDevMode = useSelector(state => state.devMode);
  // ##### Komarov 2025-08-27
  // Use the performance measurement hook
  usePerformanceMeasure('Search', {
    logToConsole: true,
    componentDevMode,
    onMeasure: (result) => {
      // You can add additional analytics or logging here
      console.log(`📊 Performance data for Search (${result.environment}):`, result);

      // Example: Send to analytics
      // analytics.track('component_performance', {
      //   ...result,
      //   page: typeof window !== 'undefined' ? window.location.pathname : 'server'
      // });
    }
  });
  // ##### 24-03-21 Komarov
  // const promoCode = useSelector(state => state.promocode.promocode);
  // ##### 24-02-28 Komarov
  const isWhiteLabelSet = useSelector(state => state.whitelabel.set);
  // ##### 24-05-22 Komarov
  const switcherRef = useRef();

  // ##### 24-09-09 Komarov
  const searchContextValue = useMemo(
    () => ({
      switcherRef,
    }),
    [
      switcherRef,
    ]
  ); // value is cached by useMemo

  // ##### 23-02-14 Komarov
  return (
    // ##### 24-05-22 Komarov
    <SearchContext.Provider value={searchContextValue}>
      {/* ##### 24-02-28 Komarov */}
      <div
        // ##### Komarov 2025-07-24
        data-component="SearchSsr"
        // ##### 23-10-25 Komarov
        style={
          (!isWhiteLabelSet && {
            marginTop: '2vh',
            // ##### 24-03-21 Komarov
            order: style?.order || null,
          }) || {
            // ##### 24-03-21 Komarov
            order: style?.order || null,
          }
        }
      >
        {/* ##### 23-11-02 Komarov */}
        <Media greaterThanOrEqual="Laptop-1024-1440">
          <LargeScreenSearch
            formClass="mySearch"
            autocompleteClass="Autocomplete"
            datepickerClass="datePicker"
            switcherRef={switcherRef}
          />
        </Media>
        { /* ##### Komarov 2025-07-21 */}
        <Media between={['Mobile-L-425-768', 'Laptop-1024-1440']}>
          <SmallScreenSearchTag
            wrapper="formOuterWrapper_inner_SmallLandscape"
            datepickerClass="datePicker_inner_MobileLandscape"
            switcherRef={switcherRef}
          />
        </Media>
        <Media lessThan="Mobile-L-425-768">
          <SmallScreenSearchTag
            wrapper="formOuterWrapper_inner_SmallPortrait"
            datepickerClass="datePicker_inner"
            switcherRef={switcherRef}
          />
        </Media>
      </div>
    </SearchContext.Provider>
  );
};

export default Search;
